import {Component, ElementRef, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {Router} from "@angular/router";
import {TokenService} from "../../../services/auth/token.service";
import {ProductionReceiptsService} from "../data/production-receipts.service";
import {TranslateService} from "../../../services/multilingual/translate.service";
import {PlantsService} from "../../company/data/plants.service";
import {OrdersService} from "../../projects/data/orders.service";
import {JBMSelectOption} from "../../../components/JBM/Forms/JBMFormGroups/JBMSelect/JBMSelect.component";
import {JBMToastsService} from "../../../components/JBM/Views/JBMToasts/JBMToasts.service";
import {Subscription} from "rxjs";
import {QueryHttpHelper, SearchColumnType} from "../../../components/JBM/Helpers/QueryHttpHelper";
import {
    JBMTableActionDef,
    JBMTableColumnAlignment,
    JBMTableColumnDef,
    JBMTableColumnType,
    JBMTableComponent
} from "../../../components/JBM/JBMTable/JBMTable.component";
import {GroupRights} from "../../users/data/interfaces/grouprights";
import {ModalService} from "../../../components/JBM/JBMModal/service/modal.service";
import {HttpParams} from '@angular/common/http';

@Component({
  selector: 'production-receipts',
  templateUrl: './production-receipts.component.html',
  styleUrls: ['./production-receipts.component.scss']
})
export class ProductionReceiptsComponent implements OnInit, OnDestroy {
  projectRights: GroupRights;
  recipeRights: GroupRights;
  dropReceiptRights: GroupRights;
  language: string;
  plants: any[]=[];
  receipts: any[]=[];
  plantTotals: any[]=[];
  id: number
  receipt_id: number
  order_id: number
  recipe_id: number;
  plantOptions: JBMSelectOption[]=[];
  plants_id: number=0;
  columnDefs: JBMTableColumnDef[];
  actionDefs: JBMTableActionDef[];

  queryHttpHelper: QueryHttpHelper;
  searchboxVisible = true;
  search = '';
  filtersVisible = false;
  loading = false;

  // Date range filtering
  fromDate: number=0;
  toDate: number=0;

  unsynchronised: number=0;

  count$: Subscription;

  timer: any;

  @ViewChild('table') table: JBMTableComponent;

  @ViewChild('dropTemplate') dropTemplate: TemplateRef<any>;
  @ViewChild('orderTemplate') orderTemplate: TemplateRef<any>;
  @ViewChild('truckTemplate') truckTemplate: TemplateRef<any>;
  @ViewChild('recipeTemplate') recipeTemplate: TemplateRef<any>;
  @ViewChild('expandTemplate') expandTemplate: TemplateRef<any>;

  @ViewChild('modalRecipeDetails') modalRecipeDetails: ElementRef;
  @ViewChild('modalDrop') modalDrop: ElementRef;

  constructor(
      private Router: Router,
      private TokenService: TokenService,
      private ProductionReceiptsService: ProductionReceiptsService,
      private OrdersService: OrdersService,
      private ModalService: ModalService,
      private JBMToastsService: JBMToastsService,
      private PlantsService: PlantsService,
      private TranslateService: TranslateService
  ) {
    this.language=this.TokenService.getLanguage();

    this.projectRights=this.TokenService.getRightsByName('projects');
    this.recipeRights=this.TokenService.getRightsByName('recipes');
    this.dropReceiptRights=this.TokenService.getRightsByName('drop_receipts');

    this.columnDefs = [
      { name: 'id', type: JBMTableColumnType.id },
      { name: 'orders_id', type: JBMTableColumnType.number, align: JBMTableColumnAlignment.left,
        header: this.TranslateService.GetTranslation('project.order') + ' ' + this.TranslateService.GetTranslation('ui.id'),
        sortable: true, filterable: true, width: 7.5 },
      { name: 'receipts_id', type: JBMTableColumnType.number, align: JBMTableColumnAlignment.left,
        header: this.TranslateService.GetTranslation('production.receipt') + ' ' + this.TranslateService.GetTranslation('ui.id'),
        sortable: true, filterable: true, width: 5 },
      { name: 'plant', type: JBMTableColumnType.string, align: JBMTableColumnAlignment.left,
          header: this.TranslateService.GetTranslation('company.plant'), width: 9 },
      { name: 'customer', header: this.TranslateService.GetTranslation('entity.customer'), sortable: true, filterable: true, width: 14 },
      { name: 'driver', header: this.TranslateService.GetTranslation('production.truck'),
        sortable: true, filterable: true, width: 12 },
      { name: 'execute_date', type: JBMTableColumnType.date, header: this.TranslateService.GetTranslation('datetime.date'),
        sortable: true, width: 5 },
      { name: 'loading_time', type: JBMTableColumnType.time, header: this.TranslateService.GetTranslation('datetime.start'), iconClassname: 'far fa-clock', width: 3.5 },
      { name: 'leave_plant_time', type: JBMTableColumnType.time, header: this.TranslateService.GetTranslation('datetime.stop'), iconClassname: 'far fa-clock', width: 3.5 },
      { name: 'receipt_amount', type: JBMTableColumnType.number, header: this.TranslateService.GetTranslation('production.produced'), align: JBMTableColumnAlignment.right,
        sortable: true, filterable: true, width: 7, className: 'pr-3' },
      { name: 'recipe', header: this.TranslateService.GetTranslation('entity.recipe'),
        sortable: false, filterable: true },
      { name: 'details', width: 3 },
      { name: 'drop', width: 4 }
    ];
    this.queryHttpHelper = new QueryHttpHelper();

    this.queryHttpHelper.addAliasedColumn('receipts_id','r.receipts_id');
    this.queryHttpHelper.addAliasedColumn('orders_id','r.orders_id');
    this.queryHttpHelper.addAliasedColumn('loading_time','r.loading_time');
    this.queryHttpHelper.addAliasedColumn('leave_plant_time','r.leave_plant_time');

    this.queryHttpHelper.addAliasedColumn('customer','c.name');
    this.queryHttpHelper.addAliasedColumn('driver','d.name');
    this.queryHttpHelper.addAliasedColumn('recipe','re.code');

    this.queryHttpHelper.setSortColumn('receipts_id',true);
    this.queryHttpHelper.addSearchColumn('orders_id', SearchColumnType.number);
    this.queryHttpHelper.addSearchColumn('receipts_id', SearchColumnType.number);
    this.queryHttpHelper.addSearchColumn('receipt_amount', SearchColumnType.number);
    this.queryHttpHelper.addSearchColumn('recipe', SearchColumnType.string);
    this.queryHttpHelper.addSearchColumn('driver', SearchColumnType.string);
  }
  ngOnInit(): void {
    this.PlantsService.getData(null).subscribe(
        (data)=>this.plants=data.data,(error)=>console.error(error),()=>{

          this.columnDefs[1].template = this.orderTemplate;
          this.columnDefs[5].template = this.truckTemplate;
          this.columnDefs[10].template = this.recipeTemplate;
          this.columnDefs[11].template = this.expandTemplate;
          this.columnDefs[12].template = this.dropTemplate;

          this.queryHttpHelper.paginationProps.pageSize=this.table.getRowCount();

          this.countUnsynchronised();
          this.getData(true);
        }
    );
  }
  countUnsynchronised() {
    this.ProductionReceiptsService.getCountUnsynchronised().subscribe(
    (data)=>this.unsynchronised=data.data,(error)=>console.error(error))
  }
  getReceiptTotals() {
      let params=new HttpParams();
      if(this.fromDate) {
          params=params.append('fromdate', this.fromDate.toString());
          params=params.append('todate', this.toDate.toString());
      }
      this.ProductionReceiptsService.getReceiptTotals(params).subscribe(
        (data)=>this.plantTotals=data.data,(error)=>console.error(error),()=> {
          this.plantOptions=[];
          if(this.plantTotals.length<2) return;
          let plants=[];
          for(let plant of this.plants) {
              if(this.plantTotals.findIndex(p => p.id===plant.id) > -1)
                  plants.push(plant);
          }
          this.plantOptions=this.PlantsService.getSelectOptions(plants);
          this.plantOptions.unshift({ key: '0', value: this.TranslateService.GetTranslation('ui.all')})
      })
  }
  getData(countRows:boolean=false) {
    this.loading = true;
    clearTimeout(this.timer);

    let params=this.setParams();
    this.ProductionReceiptsService.get(params).subscribe(
        (data)=>this.receipts=data.data,
        (error)=>console.error(error),
        ()=> {
          this.loading=false;
          this.formatData();

          this.getReceiptTotals();

          if(!countRows)
            return;

          let params=this.setParams(true);
          this.count$=this.ProductionReceiptsService.get(params).subscribe(
            (data: any)=>this.queryHttpHelper.paginationProps.itemCount=data.data,
            (error)=>console.error(error),
            ()=>
              // Refresh view every minute (Periodically poll or server refresh)
              this.timer=setTimeout(()=> this.getData(true),60000)
          );
        }
    )
  }
  setParams(countRows=false) {
      let params=this.queryHttpHelper.getHttpParams(false);
      if(this.plants_id) params=params.append('plants_id', this.plants_id.toString());
      if(this.fromDate) {
          params=params.append('fromdate', this.fromDate.toString());
          params=params.append('todate', this.toDate.toString());
      }
      params=params.append('check_production_lines','1');

      if(countRows)
          params=params.append('count','1');

      return params;
  }
  formatData() {
    for(let receipt of this.receipts) {
        receipt.receipt_amount=receipt.receipt_amount.toString().replace('.',',') + ' ' + this.TranslateService.GetTranslation('quantity.m3');
    }
  }
  rowCountChange(rowCount) {
    this.queryHttpHelper.paginationProps.pageSize=rowCount;
    this.getData();
  }
  changePlant(event) {
    this.plants_id=parseInt(event.target.value);

    this.queryHttpHelper.clearFilters();
    for(let c=0; c<this.table.columnDefs.length; c++)
        this.table.columnDefs[c].filterValue='';
    this.queryHttpHelper.setSearchValue('');

    this.getData(true);
  }
  setDateRange(event) {
    this.fromDate=event.fromUnixTime;
    this.toDate=event.toUnixTime;
    this.getData(true);
  }
  undoDateRange() {
    this.fromDate=0;
    this.toDate=0;
    this.getData(true);
  }

  // Event handling
  pageChange(page) {
      this.queryHttpHelper.paginationProps.page = page;
      this.getData();
  }
  searchChange(event) {
      let value = event.value;
      const minlength = event.minlength;
      value = value.length < minlength ? '' : value;
      if (this.queryHttpHelper.getSearchValue() !== value) {
          this.queryHttpHelper.setSearchValue(value);
          this.getData(true);
      }
  }
  sortChange(event) {
      this.queryHttpHelper.setSortColumn(event.name, event.descending);
      this.getData();
  }
  toggleFilters(event) {
      this.filtersVisible = !this.filtersVisible;
      this.queryHttpHelper.clearFilters();
      for(let c=0; c<this.table.columnDefs.length; c++)
          this.table.columnDefs[c].filterValue='';
      this.queryHttpHelper.setSearchValue('');
      this.getData(true);
  }
  filterChange(event) {
      // Delete receipt id number filter when another filter becomes active
      if(event.name!=='receipts_id') {
          this.queryHttpHelper.deleteFilterItem('receipts_id');
          this.table.resetColumnFilter('receipts_id');
      }
      // Delete other filters when receipt id number filter becomes active
      if(event.name==='receipts_id') {
          this.queryHttpHelper.clearFilters();
          this.table.resetColumnFilters();
      }

      // Delete order id number filter when another filter becomes active
      if(event.name!=='orders_id') {
          this.queryHttpHelper.deleteFilterItem('orders_id');
          this.table.resetColumnFilter('orders_id');
      }
      // Delete other filters when order id number filter becomes active
      if(event.name==='orders_id') {
          this.queryHttpHelper.clearFilters();
          this.table.resetColumnFilters();
      }

      this.queryHttpHelper.setFilterItem(event.name, event.value);
      this.getData(true);
  }
  rowSelect(row) {
    if(!row.has_production_lines) return;
    this.table.toggleRowExpanded(row);
  }
  recipeDetails(order_id: number, recipe_id: number) {
    this.order_id=order_id;
    this.recipe_id=recipe_id;
    this.ModalService.open(this.modalRecipeDetails,'recipeDetails')
  }
  drop(data: any) {
    this.id=data.id
    this.receipt_id=data.receipts_id
    this.ModalService.open(this.modalDrop,'dropReceipt')
  }
  successDrop() {
    this.ModalService.close('dropReceipt')
    this.getData(true)
  }
  closeDrop() {
    this.ModalService.close('dropReceipt')
  }
  closeRecipe() {
    this.ModalService.close('recipeDetails')
  }
  redirectToOrder(order_id: number) {
    let order={ projects_id: 0 };
    this.OrdersService.getOne(order_id, this.language).subscribe(
        (data)=>order=data.data,
        (error)=>console.error(error),
        ()=>
            this.Router.navigateByUrl('projects/'+order.projects_id+'/orders/edit/'+order_id)
    )
  }
  confirmDelete(receipt_id: number) {
    this.ProductionReceiptsService.remove(receipt_id).subscribe(
        ()=>{},(error)=>console.error(error),
        ()=> {
            this.JBMToastsService.success(this.TranslateService.GetTranslation('ui.entity-deleted'));
            this.getData(true);
        }
    );
  }
  synchronise() {
      this.Router.navigateByUrl('production/synchronisation')
  }
  ngOnDestroy(): void {
    clearTimeout(this.timer);

    // Clean up observable subscriptions to avoid memory leaks
    if(this.count$!=undefined) this.count$.unsubscribe();
  }
}
